import React, { useCallback, useEffect, useState, useTransition } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import CustomSelectBox from '../../atoms/CustomSelectBox';
import { Col, Row, Spin } from 'antd';
import { debounce } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import {
  warehouseStockSearch,
  warehouseStockSearchReset,
} from '../../redux/slice/warehouseStock/warehouseStockSearchSlice';

const SalesScreenRightHeader = ({ getInputFromDropdown }) => {
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [isPending, startTransition] = useTransition();
  const dispatch = useDispatch();
  const { status, data } = useSelector((state) => state.warehouseStockSearchState);

  const fetchSuggestions = useCallback(
    debounce((query) => {
      startTransition(() => {
        setLoading(true);
        dispatch(warehouseStockSearch(query));
      });
    }, 500),
    [dispatch, startTransition],
  );

  useEffect(() => {
    if (status === 'success') {
      startTransition(() => {
        const formattedOptions = data.map((item) => ({
          value: item.warehouseStockID,
          label: item.productName,
        }));
        setOptions(formattedOptions);
        setLoading(false);
      });
    } else if (status === 'error') {
      startTransition(() => {
        setLoading(false);
      });
    }
  }, [status, data, startTransition]);

  const handleSearch = (query) => {
    setInputValue(query);
    if (query.length >= 2) {
      fetchSuggestions(query);
    } else {
      setOptions([]);
      dispatch(warehouseStockSearchReset());
    }
  };

  const handleChange = (value) => {
    getInputFromDropdown(value);
    setInputValue('');
    setOptions([]);
  };

  return (
    <>
      <Row gutter={[16, 16]} align='middle'>
        <Col xs={24} md={16}>
          <CustomSelectBox
            style={{ height: '50px', width: '100%', margin: '10px' }}
            size='large'
            showSearch
            onSearch={handleSearch}
            notFoundContent={loading ? <Spin size='small' /> : null}
            filterOption={false}
            placeholder='Scan/Search Products by Product Name'
            options={options}
            value={inputValue}
            onChange={handleChange}
            allowClear
          />
        </Col>
      </Row>
    </>
  );
};

export default SalesScreenRightHeader;
